var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionBlueIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8216 24.285C30.0741 24.285 34.3321 19.9466 34.3321 14.595C34.3321 9.24336 30.0741 4.905 24.8216 4.905C19.5691 4.905 15.311 9.24336 15.311 14.595C15.311 19.9466 19.5691 24.285 24.8216 24.285Z",
    fill: "#006CB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9167 42H41.2223V44.1H30.9167V42Z",
    fill: "#006CB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 45V49.5C22.0833 49.8978 22.2384 50.2794 22.5145 50.5607C22.7906 50.842 23.165 51 23.5555 51H48.5833C48.9737 51 49.3482 50.842 49.6243 50.5607C49.9004 50.2794 50.0555 49.8978 50.0555 49.5V34.5C50.0555 34.1022 49.9004 33.7206 49.6243 33.4393C49.3482 33.158 48.9737 33 48.5833 33H38.2777V30.795C38.2777 30.3972 38.1226 30.0156 37.8465 29.7343C37.5704 29.453 37.196 29.295 36.8055 29.295C36.415 29.295 36.0406 29.453 35.7645 29.7343C35.4884 30.0156 35.3333 30.3972 35.3333 30.795V33H32.3888V27.63C29.8871 27.2137 27.3565 27.003 24.8216 27C19.2313 26.9758 13.7036 28.1994 8.62716 30.585C7.79165 30.9867 7.08679 31.6242 6.5962 32.4218C6.10561 33.2195 5.84989 34.1437 5.85939 35.085V45H22.0833ZM47.1111 48H25.0277V36H35.3333V36.63C35.3333 37.0278 35.4884 37.4094 35.7645 37.6907C36.0406 37.972 36.415 38.13 36.8055 38.13C37.196 38.13 37.5704 37.972 37.8465 37.6907C38.1226 37.4094 38.2777 37.0278 38.2777 36.63V36H47.1111V48Z",
    fill: "#006CB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionBlueIcon3);
export default __webpack_public_path__ + "static/media/accordion-blue-icon3.b9e92d822af68f7cd565ec653ff34a78.svg";
export { ForwardRef as ReactComponent };